<template>
	<ParamWrapper>
		<v-switch
			v-model="localValue"
			:placeholder="param.name"
			:hint="param.description"
			:persistent-hint="!!param.description ? true : false"
			:rules="fieldRules"
			v-bind="$attrs"
		>
		</v-switch>
	</ParamWrapper>
</template>

<script>
import InListParamTypeMixin from '../mixins/ListMixins/InListParamTypeMixin';
export default {
	name: 'InListBooleanParamType',
	mixins: [InListParamTypeMixin],
};
</script>
<style lang="scss" scoped></style>
